export const getRelationId = (relationship, e) => {
	if (!relationship.id) {
		const ind = e.data?.findIndex((x) => x.id === relationship.childId);
		const relationsId = e.data[ind]?.relation?.id;
		return relationsId;
	} else {
		return relationship.id;
	}
};
